<template>
  <UApp>
    <NuxtLoadingIndicator color="repeating-linear-gradient(to right,#637fff 0%,#1c1cf0 50%,#1c1cf0 100%)" />
    <Navbar />
    <NuxtPage />
    <AppFooter />
  </UApp>
</template>

<script setup>
const { page } = useContent()

const titleTemplate = computed(() => {
  const fallback = "Pathway - Power Your AI with Live Data"
  if (!page.value) return fallback

  const { title, layout } = page.value
  if (layout === 'page') return title || fallback
  if (!title) return fallback

  return title.toLowerCase().includes('pathway')
    ? title
    : `${title} | Pathway`
})

useHead({
  titleTemplate: titleTemplate.value,
})

if (!page.value?.thumbnail?.src && (!page.value?.thumbnail || !page.value)) {
  // Auto-thumbnails
  if (page.value?._path.includes("/developers")) {
    const breadCrumb = page.value._path.split("/")[2]
    const devIcons = {
      "user-guide": "heroicons:academic-cap-16-solid",
      "api-docs": "heroicons:code-bracket-16-solid",
      "showcases": "heroicons:bolt-16-solid"
    }
    defineOgImageComponent('OGImageDev', {
      headline: 'Developers / ' + breadCrumb,
      title: titleTemplate.value.replace("| Pathway", ""),
      description: page.value.description || '',
      icon: devIcons[breadCrumb] || "heroicons:code-bracket-16-solid"
    })
  } else {
    defineOgImageComponent('OGImage', {
      headline: 'Pathway',
      title: titleTemplate.value.replace("| Pathway", ""),
      description: page.value?.description || '',
    })
  }
} else {
  useHead({
    meta: [
      //   // Twitter
      { name: 'twitter:card', content: 'summary_large_image' },
      { name: 'twitter:image', content: getThumbnail() },
      { name: 'twitter:title', content: titleTemplate.value },
      { name: 'twitter:description', content: page.value?.description || "Python ETL framework for stream processing, real-time analytics, RAG, and LLM pipelines" },

      // Open Graph / Facebook
      { property: 'og:type', content: 'website' },
      { property: 'og:title', content: titleTemplate.value },
      { property: 'og:description', content: page.value?.description || "Python ETL framework for stream processing, real-time analytics, RAG, and LLM pipelines" },
      { property: 'og:image', content: getThumbnail() },
      { property: 'og:image:width', content: '1200px' },
      { property: 'og:image:height', content: '628px' }
    ]
  })
}

function getThumbnail () {
  const origin = process.client ? window?.location?.origin : "https://pathway.com"
  const originS3 = "https://d14l3brkh44201.cloudfront.net"

  let thumbnail = isObject(page.value?.thumbnail) ? page.value?.thumbnail?.src : page.value?.thumbnail
  console.log("THUMBNAIL:", thumbnail)
  if (!thumbnail) {
    return originS3 + '/assets/blog/thumbnails/pathway-card.png'
  }
  if (isValidUrl(thumbnail)) {
    return thumbnail
  }
  const separator = thumbnail?.startsWith('/') ? '' : '/'

  if (page.value?.thumbnail?.provider?.toLowerCase() === 's3') {
    return originS3 + separator + thumbnail
  }

  return origin + separator + thumbnail
}

// Article keywords
if (page.value?.keywords) {
  useHead({ meta: [{ name: "keywords", content: page.value.keywords.join(", ") }] })
}

function isObject (val) {
  return val !== null && typeof val === 'object' && !Array.isArray(val);
}

function isValidUrl (urlString) {
  try {
    return Boolean(new URL(urlString))
  } catch (e) {
    return false
  }
}

onMounted(() => {

  /* Signals */
  (function () {
    if (typeof window === 'undefined') return;
    if (typeof window.signals !== 'undefined') return;
    var script = document.createElement('script');
    script.src = 'https://cdn.cr-relay.com/v1/site/fb0135f9-6ee0-4900-9eee-0c7c7b46983f/signals.js';
    script.async = true;
    window.signals = Object.assign(
      [],
      ['page', 'identify', 'form'].reduce(function (acc, method) {
        acc[method] = function () {
          signals.push([method, arguments]);
          return signals;
        };
        return acc;
      }, {})
    );
    document.head.appendChild(script);
  })();

  useHead({
    link: [
      {
        rel: 'stylesheet',
        href: 'https://cdn.jsdelivr.net/npm/katex@0.15.0/dist/katex.min.css',
        as: 'style',
        onload: 'this.onload=null;this.rel="stylesheet"'
      }
    ]
  })
})

useSchema()
</script>
